let featuredImage: HTMLImageElement;
/**
 * Initializes the gallery.
 *
 * @param thumbnailSelector The selector for the thumbnails.
 * @param featuredImageID The ID of the featured image.
 */
export function initializeGallery(
	thumbnailSelector: string,
	featuredImageID: string,
): void {
	featuredImage = document.getElementById(featuredImageID) as HTMLImageElement;
	const elements = document.querySelectorAll<HTMLElement>(thumbnailSelector);
	elements.forEach((element) =>
		element.addEventListener("click", () => switchImage(element)),
	);
}

/**
 * Handles switching to the event target image.
 *
 * @param clickedElement The clicked element.
 */
function switchImage(clickedElement: HTMLElement) {
	if (featuredImage) {
		featuredImage.src = clickedElement.dataset.path || "";
	}
}
